<template>
  <div>
    <!-- SalesCardPreview -->
    <SalesCard class="mt-3" v-if="newComponentStore.newComponent.data"
      :show-chart="true" :report-index="-1" :center="centerId" />
  </div>
</template>
<script setup lang="ts">
import { onMounted, computed } from 'vue';
import { useNewComponentStore } from '../stores/newComponentStore'
import SalesCard from './SalesCard.vue';
import { useI18n } from 'vue-i18n';
import { useAppSettingsStore } from '../stores/AppSettingsStore';
const { t } = useI18n();

const newComponentStore = useNewComponentStore();
const appSettingsStore = useAppSettingsStore();

console.log('DEBUG SalesCardPreview: appSettingsStore =', appSettingsStore)
console.log('DEBUG SalesCardPreview: appSettingsStore.centers =', appSettingsStore.centers)
const centerId = appSettingsStore.centers[0]?.id;


const defaultTitle = computed(() => {
  return t(`newcomponent.chart.chart.preview.new_title.${newComponentStore.newComponent.type}`, {
    periodBefore: newComponentStore.newComponent.periodBeforeDate,
  })
});

onMounted(() => {
  if (!newComponentStore.newComponent.title) {
    newComponentStore.newComponent.title = defaultTitle.value;
  }
})
</script>